import { FC } from "react";
import {
  FieldValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import { TextField } from "@mui/material";
import { ButtonCancelA } from "../../common/components/ButtonCancelA";
import { SearchButton } from "../../common/components/SearchButton";

type ParentCompanySearchProps = {
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues, FieldValues>;
  reset: UseFormReset<FieldValues>;
  setCompanySearch: (val: string) => void;
  setOrganizationSearch: (val: string) => void;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  onAtomReset?: () => void;
};

export const ParentCompanySearch: FC<ParentCompanySearchProps> = ({
  register,
  handleSubmit,
  reset,
  setCompanySearch,
  setOrganizationSearch,
  setPage,
  onAtomReset,
}) => {
  const handleSubmitSearch = (data: any) => {
    setCompanySearch(data.companyName ?? "");
    setOrganizationSearch(data.organizationName ?? "");
    setPage(0);
  };

  const handleReset = () => {
    reset({ companyName: "", organizationName: "" });
    setCompanySearch("");
    setOrganizationSearch("");
    setPage(0);
    onAtomReset?.();
  };

  return (
    <div className="mt-9 border-2 pt-7 pb-7">
      <form onSubmit={handleSubmit(handleSubmitSearch)}>
        <div className="flex flex-row justify-center items-center gap-8">
          <div className="flex flex-row items-center">
            <label className="font-bold mr-3 whitespace-nowrap">Company</label>
            <TextField
              {...register("companyName")}
              defaultValue={""}
              sx={{ "& .MuiInputBase-input": { height: "5px" } }}
            />
          </div>
          <div className="flex flex-row items-center">
            <label className="font-bold mr-3 whitespace-nowrap">Organization</label>
            <TextField
              {...register("organizationName")}
              defaultValue={""}
              sx={{ "& .MuiInputBase-input": { height: "5px" } }}
            />
          </div>
        </div>
        <div className="flex flex-center justify-center mt-10 gap-5">
          <ButtonCancelA
            name="Reset"
            onHandleClick={handleReset}
            icon={<ClearIcon />}
          />
          <SearchButton />
        </div>
      </form>
    </div>
  );
};
